export interface ContextRoleProfileApproverRoleDTO {
    contextName?: string;
    roleName?: string;
    profileName?: string;
    approverRoleName?: string;
    approvalLevel?: number;
    idbApps?: string;
}
